module.exports = __webpack_public_path__ + "assets/icon-conductor-net.29b4187f.svg";